import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(protected http: HttpClient) {}

  protected url = '/web/';
  // protected url = '/api/web/'; // 3020

  protected dict = '/merchant/dictionary/';
  // protected dict = '/api/dictionary/'; //3020

  protected urlmerch = 'saveClientRequest';
  protected urlfaq = 'getFaqList';
  protected urlnews = 'getNewsList';
  protected urlnewsdetail = 'getNewsDetail';
  protected urlbanner = 'getBannerList';

  protected dictCity = 'dictCity';
  protected dictDist = 'dictDist';
  protected dictSubDist = 'dictSubDist';

  protected tempTkn = 'DCuanJs6FkuCK0TKiYvlzy9StTDt7B';
  // protected tempTkn = '5V2FkdO9nAwKD2oCP24xN8S2uWCPBs'; //3020

  retrieve(operation: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      lang: this.getLang(),
    });

    return this.http.get(this.url + this.urlmerch, { headers }).pipe(
      map((res) => res as any),
      catchError((err) => this.convertError(err))
    );
  }

  private getLang(): string {
    return sessionStorage.getItem('lang')
      ? sessionStorage.getItem('lang')
      : 'mn';
  }

  private convertError(httpError: HttpErrorResponse) {
    const { status, message, error } = httpError;
    let msg = error;
    switch (status) {
      case 504:
      case 413:
        msg = status + ' ' + message;
        break;
      case 404:
        msg = 'Сервер ачаалагдаагүй байна. Системийн админд хандана уу';
        break;
      default:
        msg = error;
    }

    // this.events.emit(new ApiEvent(status, request, error));
    return throwError(msg);
  }

  /**
   * Post хүсэлт - Insert хийнэ
   * @category HTTP хүсэлтүүд
   * @param operation : Хандах хаяг (URL)
   * @param body : Хүсэлтийн body
   * @returns Observable буцаана
   */

  getToken(){

  }

  post(operation: string, body: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    var res = this.http
      .post(
        this.url + this.urlmerch,
        JSON.stringify(body, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
    return res;
  }

  getNews(newslistcount) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.url + this.urlnews,
        JSON.stringify(newslistcount, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getNewsDetail(newsId) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.url + this.urlnewsdetail,
        JSON.stringify(newsId, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getFaq(faq) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.url + this.urlfaq,
        JSON.stringify(faq, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getDict(data) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'app-id': '3',
      'app-secret': 'SCF',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.dict + this.dictCity,
        JSON.stringify(data, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getDist(data) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'app-id': '3',
      'app-secret': 'SCF',
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.dict + this.dictDist,
        JSON.stringify(data, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getSubDist(data) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'app-id': '3',
      'app-secret': 'SCF',
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.dict + this.dictSubDist,
        JSON.stringify(data, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }

  getBannerList(data) {
    var sessionToken = sessionStorage.getItem("sessionToken");
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      lang: this.getLang(),
      'app-id': '3',
      'app-secret': 'SCF',
      'Access-Control-Allow-Origin': '*',
      'SESSION-TOKEN':this.tempTkn,
    });
    return this.http
      .post(
        this.url + this.urlbanner,
        JSON.stringify(data, (_, value) => {
          if (value !== null) {
            return value;
          }
        }),
        {
          headers: headers,
        }
      )
      .pipe(catchError((err) => this.convertError(err)));
  }
}
